import { render, staticRenderFns } from "./BusinessApplicationEdit.vue?vue&type=template&id=d246db56&scoped=true&"
import script from "./BusinessApplicationEdit.vue?vue&type=script&lang=js&"
export * from "./BusinessApplicationEdit.vue?vue&type=script&lang=js&"
import style0 from "./BusinessApplicationEdit.vue?vue&type=style&index=0&id=d246db56&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d246db56",
  null
  
)

export default component.exports